import { memo } from 'react';
import { Image } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { type ImageInfo } from '../../../../api/image';
import { RadioItem, type RadioItemProps } from '../RadioItem';
import styles from './PreviewRadio.module.css';

export interface PreviewRadioProps extends RadioItemProps, TestProps {
    image?: ImageInfo;
}

export const PreviewRadio = memo(function PreviewRadio({
    'data-testid': dataTestId = 'PreviewRadio',
    image,
    value,
    ...props
}: PreviewRadioProps) {
    return (
        <RadioItem {...props} data-testid={dataTestId} value={value} aria-label={`Выбрать ${value}`} title={value}>
            <div className={styles.paranja}>
                {image ? (
                    <Image fit="cover" width="100%" height="100%" src={image.file_path} borderRadius="8" alt={value} />
                ) : (
                    <div className={styles.imagePlaceholder} />
                )}
            </div>
        </RadioItem>
    );
});
